module.exports = __webpack_public_path__ + "media/images/img-family-1-31ebf36b.jpg";